import 'react';

type LoadingBarProps = {
    width?: number;
    color?: string;
    className?: string;
};
export default function LoadingBar({
    width = 0.5,
    color = 'bg-blue-500',
    className,
}: LoadingBarProps) {
    return (
        <div
            className={`left-0 w-full h-${width} bg-gray-200 overflow-hidden ${className}`}
        >
            <div
                className={`h-full w-full ${color} animate-[loading_1.5s_infinite]`}
            ></div>
            <style>
                {`
            @keyframes loading {
              0% { transform: translateX(-100%); }
              50% { transform: translateX(0); }
              100% { transform: translateX(100%); }
            }
          `}
            </style>
        </div>
    );
}
